// /src/components/guards/MobileGuard.jsx
import React from 'react';

export default function MobileGuard({ children }) {
    // BLOQUEIO REMOVIDO A PEDIDO DO MASTER
    // O sistema agora permite acesso total via dispositivos móveis (Celulares e Tablets)
    return <>{children}</>;
}